/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import type { ApiCartTimeslot } from '../../../api/timeslots/timeslotModels';

import { checkoutResetAction } from '../checkout/checkoutActions';
import { setFullCart } from './cartHydrationActions';

export const getInitialState = (): ApiCartTimeslot | null => null;

const slice = createSlice({
    name: 'timeslot',
    initialState: getInitialState(),
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.timeslot);
        builder.addCase(checkoutResetAction, () => {
            return getInitialState();
        });
    },
});

export const { actions: cartTimeslotActions, reducer: cartTimeslotReducer } = slice;
